export default "__VITE_ASSET__B6T283_A__"